export enum IconTypeEnum {
    None = 1,
    MaterialIcon = 2,
    BondProIcon = 3
}
